import { TypeOption, WrapperOption } from "@ngx-formly/core/lib/models";
import { MatTabsFieldComponent } from "./mat-tabs.type";
import { MatInputFieldComponent } from "./mat-input.type";
import { MatTextareaFieldComponent } from "./mat-textarea.type";
import { MatSelectFieldComponent } from "./mat-select.type";
import { MatCheckboxFieldComponent } from "./mat-checkbox.type";
import { MatRadioFieldComponent } from "./mat-radio.type";
import { MatDatepickerFieldComponent } from "./mat-datepicker.type";
import { MatNumberFieldComponent } from "./mat-number.type";
import { SearchInputFieldType } from "./search-input.type";
import { LocationAutocompleteFieldType } from "./location-autocomplete.type";
import { RadiusSelectFieldType } from "./radius-select.type";
import { MultiSelectPanelFieldType } from "./multi-select-panel.type";
import { RangeSliderFieldType } from "./range-slider.type";
import { TagSelectorFieldType } from "./tag-selector.type";
import { FormInputFieldComponent } from "./form-input.type";
import { FormSelectFieldComponent } from "./form-select.type";
import { CoreSelectorFieldComponent } from "./core-selector.type";
import { PercentageGroupFieldComponent } from "./percentage-group.type";
import { CompetencyPickerFieldComponent } from "./competency-picker.type";
import { FormSectionWrapperComponent } from "./section-wrapper.type";
import { CKEditorTranslatableFieldComponent } from "./ckeditor-translatable.type";
import { InputTranslatableFieldComponent } from "./input-translatable.type";
import { SegmentedControlFieldType } from "./segmented-control.type";
import { TagInputFieldType } from "./tag-input.type";
import { SkillsInputFieldType } from "./skills-input.type";
import { CompanyBlacklistInputFieldType } from "./company-blacklist-input.type";
import { RegionCheckboxesFieldComponent } from './region-checkboxes.type';
import { EducationLevelTreeFieldComponent } from './education-level-tree.type';
import { FileUploadWithHistoryFieldComponent } from './file-upload-with-history.type';
import { CoreSelectorAreaofinterestsFieldComponent } from './core-selector-areaofinterests.type';
import { MatchCriterionFieldComponent } from './match-criterion.type';
import { EducationLevelSelectorFieldComponent } from './education-level-selector.type';
import { CvUploadImportFieldComponent } from './cv-upload-import.type';
import { LanguageSelectFieldComponent } from './language-select.type';

/**
 * Custom Formly field types.
 * Register these in AppModule with FormlyModule.forRoot({ types: CUSTOM_FIELD_TYPES, wrappers: CUSTOM_WRAPPERS })
 */
export const CUSTOM_FIELD_TYPES: TypeOption[] = [
  { name: "mat-tabs", component: MatTabsFieldComponent },
  { name: "mat-input", component: MatInputFieldComponent },
  { name: "mat-textarea", component: MatTextareaFieldComponent },
  { name: "mat-select", component: MatSelectFieldComponent },
  { name: "mat-checkbox", component: MatCheckboxFieldComponent },
  { name: "mat-radio", component: MatRadioFieldComponent },
  { name: "mat-datepicker", component: MatDatepickerFieldComponent },
  { name: "mat-number", component: MatNumberFieldComponent },
  // Search filter types
  { name: "search-input", component: SearchInputFieldType },
  { name: "location-autocomplete", component: LocationAutocompleteFieldType },
  { name: "radius-select", component: RadiusSelectFieldType },
  { name: "multi-select-panel", component: MultiSelectPanelFieldType },
  { name: "language-select", component: LanguageSelectFieldComponent },
  { name: "range-slider", component: RangeSliderFieldType },
  { name: "tag-selector", component: TagSelectorFieldType },
  // Admin form types
  { name: "form-input", component: FormInputFieldComponent },
  { name: "form-select", component: FormSelectFieldComponent },
  { name: "core-selector", component: CoreSelectorFieldComponent },
  { name: "percentage-group", component: PercentageGroupFieldComponent },
  { name: "competency-picker", component: CompetencyPickerFieldComponent },
  // Translatable editor types
  { name: "ckeditor-translatable", component: CKEditorTranslatableFieldComponent },
  { name: "input-translatable", component: InputTranslatableFieldComponent },
  { name: "segmented-control", component: SegmentedControlFieldType },
  { name: "tag-input", component: TagInputFieldType },
  { name: "skills-input", component: SkillsInputFieldType },
  { name: "company-blacklist-input", component: CompanyBlacklistInputFieldType },
  // Domain-specific composite types
  { name: 'region-checkboxes', component: RegionCheckboxesFieldComponent },
  { name: 'education-level-tree', component: EducationLevelTreeFieldComponent },
  { name: 'file-upload-with-history', component: FileUploadWithHistoryFieldComponent },
  { name: 'core-selector-areaofinterests', component: CoreSelectorAreaofinterestsFieldComponent },
  { name: 'match-criterion', component: MatchCriterionFieldComponent },
  { name: 'education-level-selector', component: EducationLevelSelectorFieldComponent },
  { name: 'cv-upload-import', component: CvUploadImportFieldComponent },
];

/**
 * Custom Formly wrappers.
 */
export const CUSTOM_WRAPPERS: WrapperOption[] = [
  { name: "section-wrapper", component: FormSectionWrapperComponent },
];

// Re-export individual types for direct imports if needed
export { MatTabsFieldComponent } from "./mat-tabs.type";
export { MatInputFieldComponent } from "./mat-input.type";
export { MatTextareaFieldComponent } from "./mat-textarea.type";
export { MatSelectFieldComponent } from "./mat-select.type";
export { MatCheckboxFieldComponent } from "./mat-checkbox.type";
export { MatRadioFieldComponent } from "./mat-radio.type";
export { MatDatepickerFieldComponent } from "./mat-datepicker.type";
export { MatNumberFieldComponent } from "./mat-number.type";
export { SearchInputFieldType } from "./search-input.type";
export { LocationAutocompleteFieldType } from "./location-autocomplete.type";
export { RadiusSelectFieldType } from "./radius-select.type";
export { MultiSelectPanelFieldType } from "./multi-select-panel.type";
export { RangeSliderFieldType } from "./range-slider.type";
export { TagSelectorFieldType } from "./tag-selector.type";
export { FormInputFieldComponent } from "./form-input.type";
export { FormSelectFieldComponent } from "./form-select.type";
export { CoreSelectorFieldComponent } from "./core-selector.type";
export { PercentageGroupFieldComponent } from "./percentage-group.type";
export { CompetencyPickerFieldComponent } from "./competency-picker.type";
export { FormSectionWrapperComponent } from "./section-wrapper.type";
export { CKEditorTranslatableFieldComponent } from "./ckeditor-translatable.type";
export { InputTranslatableFieldComponent } from "./input-translatable.type";
export { SegmentedControlFieldType } from "./segmented-control.type";
export { TagInputFieldType } from "./tag-input.type";
export { SkillsInputFieldType } from "./skills-input.type";
export { CompanyBlacklistInputFieldType } from "./company-blacklist-input.type";
export { RegionCheckboxesFieldComponent } from './region-checkboxes.type';
export { EducationLevelTreeFieldComponent } from './education-level-tree.type';
export { FileUploadWithHistoryFieldComponent } from './file-upload-with-history.type';
export { CoreSelectorAreaofinterestsFieldComponent } from './core-selector-areaofinterests.type';
export { MatchCriterionFieldComponent } from './match-criterion.type';
export { EducationLevelSelectorFieldComponent } from './education-level-selector.type';
export { CvUploadImportFieldComponent } from './cv-upload-import.type';
export { LanguageSelectFieldComponent } from './language-select.type';
export type { CvUploadImportResult } from './cv-upload-import.type';
